import Types from "./types";
import { B2cFinanceService, B2cHubspotService, ListingServiceAU, UserAuthService, geoLocationService, testDriveService } from "../../service";
import { LOCAL_STORAGE_KEYS, resetReducerKeys } from "../../constants/app-constants";
import { ISLOGGEDIN_COOKIE } from "./constants";
import { proxyAuthState } from "../../service/userAuthApi";
import { AUTH_ADDRESS } from "../../constants/api-constants";
import { populateCheckoutPersonalData, populateEmailFromToken, resetCheckoutData } from "../au.mobile/checkout-info/actions";
import { populateEmailFromToken as populateEmailFromTokenDesktop } from "../au.desktop/checkout-info/actions";

import getMobileFromProfile from "../../utils/helpers/get-profile-mobile";
import { clearItem, getItem, setItem } from "../../utils/helpers/storage-crud";
import toTitleCase from "../../utils/helpers/to-title-case";
import { cleverTapLogin, updateCleverTapProfile } from "../../tracking";
import parseCookie from "../../utils/helpers/parse-cookie";
import saveCookie from "../../utils/helpers/save-cookie";
import { getDeviceType } from "../../utils/helpers/get-device-type";
import { mobileCleverTapEvent, desktopCleverTapEvent } from "../../tracking";
import { resetPreApproval } from "../au.mobile/pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { LOGIN_TYPE } from "../../constants/checkout-constants";
import { ZERO_DP_VARIANTS } from "../../constants/optimize-constants";
import jwtDecode from "jwt-decode";
import { setTestDriveVariant } from "../au.mobile/test-drive-v2/actions";
import { getPreApprovalLoanDetails } from "../au.desktop/pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { fetchConfig as fetchPreApprovalOnFlyConfig, fetchFormMetadata as fetchPreApprovalOnFlyFormMetadata } from "../au.desktop/pre-approval-on-fly-modal/actions";
import { emitEventNames } from "../../constants/event-constants";
import { GUEST_LOGIN_DATA_STATUS } from "./reducers";
import bifrostAuthService from "../../service/bifrost-auth-service";
import { isOldAuToken } from "../../utils/helpers/is-bifrost-token";
import { normalizeAUMobileNumber } from "../../utils/validators/mobile-number-validator";
import bifrostService from "../../service/bifrost-service";
import umsService from "../../service/ums-service";
import { saveBifrostAuthCookies, clearBifrostAuthCookies } from "../../utils/helpers/auth-cookie";
const setProfileName = (profileName) => ({
    type: Types.SET_PROFILE_NAME,
    profileName
});

const setMobile = (mobile) => ({
    type: Types.SET_MOBILE,
    mobile
});

const setLastVerifiedMobile = (lastVerifiedMobile) => ({
    type: Types.SET_LAST_VERIFIED_MOBILE,
    lastVerifiedMobile
});

const setProfileMobile = (profileMobile) => ({
    type: Types.SET_PROFILE_MOBILE,
    profileMobile
});

const setEmail = (email) => ({
    type: Types.SET_EMAIL,
    email
});

const setCheckAuth = (checkAuth) => ({
    type: Types.CHECK_AUTH,
    checkAuth
});

const setAffiliateSource = (affiliateSource) => ({
    type: Types.SET_AFFILIATE_SOURCE,
    affiliateSource
});

// // eslint-disable-next-line
// const getProfileDetailsSuccess = ({ email, name, mobilePhone, token }) => ({
//     type: Types.GET_PROFILE_DETAILS_SUCCESS,
//     email,
//     name,
//     token,
//     phoneNumber: mobilePhone
// });

const getProfileDetailsSuccess = (data) => {
    return {
        type: Types.GET_PROFILE_DETAILS_SUCCESS,
        data
    };
};

const getProfileDetailsFailure = (error, isGuestLogin) => ({
    type: Types.GET_PROFILE_DETAILS_FAILURE,
    error,
    isGuestLogin
});

const getProfileName = (response) => {
    const { firstName, lastName, userName } = response || {};
    if (firstName) {
        return `${toTitleCase(firstName)} ${lastName || ""}`;
    }
    const userProfile = getItem(LOCAL_STORAGE_KEYS.userProfile);
    return (userProfile && userProfile.name) || userName;
};

// eslint-disable-next-line no-unused-vars
const postUserLoginEvent = (data = {}) => dispatch => {
    const {  accessToken } = data || {};
    const params = {
        token: accessToken,
        source: getDeviceType(),
        // userId: userName,
        // source: userProfiles[0] && userProfiles[0].addressType,
        hubspotutk: parseCookie("hubspotutk")
    };
    return new Promise((resolve, reject) => {
        B2cHubspotService.userLoginEvent(params, accessToken)
            .then((response) => {
                resolve(response);
                //response
            })
            .catch((error) => {
                reject(error);
                //error
            });
    });
};

const getZeroDpConfigInit = (isLoading) => {
    return {
        type: Types.GET_ZERO_DP_VARIANT_INIT,
        data: isLoading
    };
};

const getZeroDpConfigSuccess = (data) => {
    return {
        type: Types.GET_ZERO_DP_VARIANT_SUCCESS,
        data
    };
};

const getZeroDpConfigFailure = (error) => {
    return {
        type: Types.GET_ZERO_DP_VARIANT_FAILURE,
        error
    };
};

const setInitialZeroDpOptimizeVariant = (data) => {
    return {
        type: Types.SET_INITIAL_ZERO_DP_OPTIMIIZE_VARIANT,
        data
    };
};

const getZeroDpConfig = (token, payload = {}) => async (dispatch) => {
    try {
        dispatch(getZeroDpConfigInit(true));
        // web-show-zero-downpayment scaled to variant A
        const zeroDpVariant = ZERO_DP_VARIANTS.NON_ZERO_DP;
        const params = {zeroDpVariant, ...payload};
        if (token) {
            const response = await B2cFinanceService.getZeroDpConfig(token, params);
            dispatch(getZeroDpConfigSuccess(response.data));
            Promise.resolve(response.data);
        } else {
            dispatch(getZeroDpConfigSuccess({zeroDpVariant}));
            Promise.resolve({zeroDpVariant});
        }
    } catch (error) {
        dispatch(getZeroDpConfigFailure(error));
        Promise.reject(error);
    }
};

const setSecureToken = (secureToken, isGuestLogin) => ({
    type: Types.SET_SECURE_TOKEN,
    secureToken,
    isGuestLogin
});

const setBifrostTokens = ({ secureToken, refreshToken, sessionId }) => ({
    type: Types.SET_BIFROST_TOKENS,
    secureToken,
    refreshToken,
    sessionId
});

const setPrimaryIdentifierType = (primaryIdentifierType) => ({
    type: Types.SET_PRIMARY_IDENTIFIER_TYPE,
    primaryIdentifierType
});

const openSecondaryIdentifierModal = (config = {}) => ({
    type: Types.OPEN_SECONDARY_IDENTIFIER_MODAL,
    config
});

const closeSecondaryIdentifierModal = () => ({
    type: Types.CLOSE_SECONDARY_IDENTIFIER_MODAL
});

const checkAndOpenSecondaryModal = () => () => {
    // Set the same session flag used by SSO flow — the useEffect in
    // au.configuration/component.js waits for isUmsProfileFetched before
    // checking email/mobile, avoiding the race condition where Redux
    // hasn't been populated from the UMS profile response yet.
    try {
        window.sessionStorage.setItem("bifrost_sso_pending_secondary", "1");
    } catch (e) {
        // Silently fail
    }
};

const setIsCtSub = (value) => ({
    type: Types.SET_IS_CT_SUB,
    value
});

const setSettingGuestLoginData = (payload) => ({
    type: Types.SET_SETTING_GUEST_LOGIN_DATA,
    guestLoginDataStatus: payload
});

const setIsValueCheckLoginDoneInit = (isValueCheckLoginDone) => {
    return {
        type: Types.SET_IS_VALUECHECK_LOGIN_DONE,
        isValueCheckLoginDone
    };
};
const setIsValueCheckLoginDone = (isValueCheckLoginDone) => (dispatch) => {
    dispatch(setIsValueCheckLoginDoneInit(isValueCheckLoginDone));
};
const setUserEmailViaGuestLoginInit = (email) => ({
    type: Types.SET_USER_EMAIL_VIA_GUEST_LOGIN,
    email
});
const setUserMobileViaGuestLoginInit = (mobile) => ({
    type: Types.SET_USER_MOBILE_VIA_GUEST_LOGIN,
    mobile
});
const setUserEmailViaGuestLogin = (email) => (dispatch) => {
    dispatch(setUserEmailViaGuestLoginInit(email));
};
const setUserMobileViaGuestLogin = (mobile) => (dispatch) => {
    dispatch(setUserMobileViaGuestLoginInit(mobile));
};

// eslint-disable-next-line max-statements
const getProfileDetails = (token, isGuestLogin, isNewUser) => async (dispatch, getState) => {
    const {
        user: {isCtSub = false}
    } = getState();
    try {
        const response = await UserAuthService.getProfileDetails(token);
        const profileMobile = getMobileFromProfile(response.data);
        dispatch(getProfileDetailsSuccess({...response.data, profileMobile, secureToken: token, isGuestLogin, isNewUser}));
        dispatch(populateCheckoutPersonalData({...response.data, profileMobile}));
        dispatch(setCheckAuth(false));
        const profileName = getProfileName(response.data);
        setItem({ name: profileName}, "userProfile");
        dispatch(setProfileName(profileName));
        if (isNewUser && !isCtSub) {
            cleverTapLogin({mobile: profileMobile, fullName: profileName, email: (response.data || {}).userName});
            dispatch(setIsCtSub(true));
        }
        if (!isNewUser) {
            dispatch(setIsCtSub(true));
        }
        // postUserLoginEvent({...response.data, profileMobile, secureToken: token});
        saveCookie(ISLOGGEDIN_COOKIE, true);
        dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
        Promise.resolve(response.data);
    } catch (error) {
        const guestLoginResponse = jwtDecode(token);
        dispatch(getProfileDetailsFailure(error, guestLoginResponse.isGuestLogin));
        dispatch(setCheckAuth(false));
        if (guestLoginResponse.isGuestLogin) {
            // dispatch(populateCheckoutPersonalData(guestLoginResponse));
            // dispatch(populateCheckoutPersonalDataDesktop(guestLoginResponse));
            dispatch(setEmail(guestLoginResponse.email));
            dispatch(setMobile(normalizeAUMobileNumber((guestLoginResponse.mobilePhone || "").toString())));
            dispatch(populateEmailFromToken(guestLoginResponse));
            dispatch(populateEmailFromTokenDesktop(guestLoginResponse));
            dispatch(setSecureToken(token, guestLoginResponse.isGuestLogin));
            dispatch(setEmail(guestLoginResponse.email));
        }
        dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
        Promise.reject(error);
    }
};

// Maps a UMS profile response into the user slice. Best-effort — JWT data is
// already set by setBifrostWebviewSession; this supplements name/email/phone.
// eslint-disable-next-line complexity, max-statements
const applyUmsProfile = (dispatch, profileData, getState) => {
    const {
        first_name: umsFirst, last_name: umsLast,
        email: umsEmail, phone: umsPhone,
        is_phone_verified: isPhoneVerified, is_email_verified: isEmailVerified,
        user_id: umsUserId
    } = profileData;
    if (umsUserId) {
        dispatch({ type: Types.SET_UMS_USER_ID, umsUserId });
    }
    const normalizedMobile = umsPhone ? normalizeAUMobileNumber(umsPhone) : "";
    const fullName = (umsFirst || umsLast)
        ? `${toTitleCase(umsFirst || "")} ${umsLast || ""}`.trim()
        : "";
    if (fullName) {
        dispatch(setProfileName(fullName));
        setItem({ name: fullName }, "userProfile");
    }
    if (umsEmail) {
        dispatch(setEmail(umsEmail));
    }
    if (normalizedMobile) {
        dispatch(setMobile(normalizedMobile));
        dispatch(setProfileMobile(normalizedMobile));
    }
    // Infer primaryIdentifierType from verified flags if not already set (e.g. page refresh)
    if (getState && !getState().user.primaryIdentifierType) {
        if (isPhoneVerified && umsPhone) {
            dispatch(setPrimaryIdentifierType("phone"));
        } else if (isEmailVerified && umsEmail) {
            dispatch(setPrimaryIdentifierType("email"));
        }
    }
    dispatch({
        type: Types.SET_PROFILE_DETAILS,
        data: {
            firstName: umsFirst || "",
            lastName: umsLast || "",
            fullName: fullName || "",
            phoneNumberVerified: !!isPhoneVerified,
            emailVerified: !!isEmailVerified
        }
    });
    dispatch(populateCheckoutPersonalData({
        firstName: umsFirst || "",
        lastName: umsLast || "",
        profileMobile: normalizedMobile,
        userName: umsEmail || ""
    }));
};

const fetchUmsProfile = (token) => (dispatch, getState) => {
    dispatch({ type: Types.SET_PROFILE_DETAILS, data: { isUmsProfileFetched: false } });
    umsService.getUserProfile(token).then((response) => {
        const profileData = response?.data || response || {};
        const topLevelUserId = response?.user_id;
        if (topLevelUserId && !profileData.user_id) {
            profileData.user_id = topLevelUserId;
        }
        applyUmsProfile(dispatch, profileData, getState);
    }).catch(() => {
        // UMS profile fetch is best-effort; JWT data is already set
    }).finally(() => {
        dispatch({ type: Types.SET_PROFILE_DETAILS, data: { isUmsProfileFetched: true } });
    });
};

// Establish a logged-in session from a Bifrost access token handed in via the
// webview URL (e.g. test-drive). The token is already a valid access token, so
// no refresh/exchange is needed — decode it, mark logged in, then enrich the
// profile from UMS. authProvider is set so updateProfile routes to UMS.
const setBifrostWebviewSession = (accessToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        try {
            const userData = jwtDecode(accessToken);
            dispatch(getProfileDetailsSuccess({
                ...userData,
                secureToken: accessToken,
                isGuestLogin: false,
                isNewUser: false,
                phoneNumberVerified: true
            }));
            dispatch({ type: Types.SET_PROFILE_DETAILS, data: { authProvider: "BIFROST" } });
            dispatch(setCheckAuth(false));
            saveCookie(ISLOGGEDIN_COOKIE, true);
            proxyAuthState.accessToken = accessToken;
            proxyAuthState.isLoggedIn = true;
            dispatch(fetchUmsProfile(accessToken));
            resolve(userData);
        } catch (error) {
            dispatch(setCheckAuth(false));
            reject(error);
        }
    });
};

// Exchange a UMS auth code (from app webview) for a web-client Bifrost token.
// Falls back to using the app token directly if the exchange fails.
const exchangeUmsAuthCode = (authCode, fallbackToken = "") => async (dispatch) => {
    try {
        const response = await bifrostAuthService.exchangeAuthCode(authCode);
        const { access_token: accessToken } = response?.data || {};
        if (!accessToken) throw new Error("No access_token in exchange response");
        return dispatch(setBifrostWebviewSession(accessToken));
    } catch (_error) {
        // Fallback: use the app token directly
        if (fallbackToken) {
            const cleanToken = fallbackToken.replace(/^Bearer\s+/i, "").trim();
            return dispatch(setBifrostWebviewSession(cleanToken));
        }
        return Promise.reject(_error);
    }
};

// Exchanges an old AU token for a Bifrost token via au_to_client and saves cookies.
// Returns the new access token, or null if exchange fails.
const tryExchangeOldAuToken = async (oldToken) => {
    const exchangeResponse = await bifrostAuthService.exchangeOldAuToken(oldToken);
    const newToken = exchangeResponse?.data?.access_token || exchangeResponse?.access_token;
    if (!newToken) throw new Error("No access_token from au_to_client exchange");
    saveBifrostAuthCookies({
        accessToken: newToken,
        refreshToken: exchangeResponse?.data?.refresh_token || exchangeResponse?.refresh_token,
        sessionId: exchangeResponse?.data?.session_id || exchangeResponse?.session_id,
        expiresIn: exchangeResponse?.data?.expires_in || exchangeResponse?.expires_in
    });
    return { ...exchangeResponse, token: newToken };
};

const setProfileWithToken = (token) => (dispatch) => {
    // eslint-disable-next-line max-statements
    return new Promise((resolve, reject) => {
        try {
            // eslint-disable-next-line no-undef
            const userData = JSON.parse(atob(token?.split(".")[1]));
            const profileMobile = getMobileFromProfile(userData);
            dispatch(getProfileDetailsSuccess({
                ...userData,
                profileMobile,
                secureToken: token,
                isGuestLogin: false,
                isNewUser: false,
                phoneNumberVerified: true
            }));
            dispatch(populateCheckoutPersonalData({...userData, profileMobile}));
            dispatch(setCheckAuth(false));
            const profileName = getProfileName(userData);
            setItem({ name: profileName}, "userProfile");
            dispatch(setProfileName(profileName));
            saveCookie(ISLOGGEDIN_COOKIE, true);
            dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
            // Fetch full profile from UMS to supplement JWT data
            dispatch(fetchUmsProfile(token));
            resolve(userData);
        } catch (error) {
            dispatch(setCheckAuth(false));
            reject(error);
        }
    });
};

/* eslint-disable max-statements */
const getRefreshTokenInfo = () => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const existingAccessToken = parseCookie("bifrost_token");
        const existingRefreshToken = parseCookie("bifrost_refresh_token");
        const existingSessionId = parseCookie("bifrost_session_id");

        const setAuthenticatedState = ({ token, refresh_token: refreshToken = existingRefreshToken, session_id: sessionId = existingSessionId, expires_in: expiresIn }) => {
            const accessToken = token;
            proxyAuthState.accessToken = accessToken;
            proxyAuthState.expiresIn = expiresIn || proxyAuthState.expiresIn;
            proxyAuthState.isLoggedIn = true;
            dispatch(setBifrostTokens({
                secureToken: accessToken,
                refreshToken,
                sessionId
            }));
            dispatch(setProfileWithToken(accessToken));
            dispatch(getZeroDpConfig(accessToken));
            dispatch(getPreApprovalLoanDetails({fetchListingDetails: true, accessToken}));
            // Prefetch on-fly form data if user is in variant B
            const { abExperiment: { preApprovalOnFlyDesktop, preApprovalOnFlyMsite } = {} } = getState();
            const deviceType = getDeviceType();
            const onFlyVariant = deviceType === "MOBILE" ? preApprovalOnFlyMsite : preApprovalOnFlyDesktop;
            if (onFlyVariant && onFlyVariant.data === "VARIANT_B") {
                dispatch(fetchPreApprovalOnFlyConfig());
                dispatch(fetchPreApprovalOnFlyFormMetadata());
            }
            resolve({
                access_token: accessToken,
                refresh_token: refreshToken,
                session_id: sessionId,
                expires_in: expiresIn
            });
        };

        if (existingAccessToken) {
            bifrostService.introspectToken({ token: existingAccessToken }).then((introspectionResponse) => {
                if (introspectionResponse?.active) {
                    setAuthenticatedState({ token: existingAccessToken });
                    return;
                }

                if (!existingRefreshToken || !existingSessionId) {
                    throw new Error("No valid bifrost refresh session found");
                }

                bifrostService.refreshToken({
                    refreshToken: existingRefreshToken,
                    sessionId: existingSessionId
                }).then(setAuthenticatedState);
            }).catch(error => {
                proxyAuthState.accessToken = null;
                proxyAuthState.isLoggedIn = false;
                dispatch(getZeroDpConfig(null));
                dispatch(getProfileDetailsFailure(error, false));
                dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
                reject(error);
            });
            return;
        }

        if (existingRefreshToken && existingSessionId) {
            bifrostService.refreshToken({
                refreshToken: existingRefreshToken,
                sessionId: existingSessionId
            }).then(setAuthenticatedState).catch(error => {
                proxyAuthState.accessToken = null;
                proxyAuthState.isLoggedIn = false;
                dispatch(getZeroDpConfig(null));
                dispatch(getProfileDetailsFailure(error, false));
                dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
                reject(error);
            });
            return;
        }

        // Fallback 1: check for old AU token in client-readable cookie
        const legacyToken = parseCookie("token");
        if (legacyToken && isOldAuToken(legacyToken)) {
            tryExchangeOldAuToken(legacyToken).then(result => {
                setAuthenticatedState({
                    token: result.token,
                    refresh_token: result?.data?.refresh_token || result?.refresh_token,
                    session_id: result?.data?.session_id || result?.session_id,
                    expires_in: result?.data?.expires_in || result?.expires_in
                });
            }).catch(exchangeError => {
                proxyAuthState.accessToken = null;
                proxyAuthState.isLoggedIn = false;
                dispatch(getZeroDpConfig(null));
                dispatch(getProfileDetailsFailure(exchangeError, false));
                dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
                reject(exchangeError);
            });
            return;
        }

        // Fallback 2: try legacy auth service (uses HttpOnly cookies on auth domain)
        // Old AU auth stores refresh tokens as HttpOnly cookies that parseCookie can't read.
        // The legacy endpoint sends them automatically via withCredentials.
        const { user: { affiliateSource: source, isAffiliate } } = getState();
        const headersObj = { ...(isAffiliate && { referrersource: source }) };
        UserAuthService.getRefreshTokenInfo(headersObj).then(response => {
            const { access_token: legacyAccessToken } = response.data || {};

            if (!legacyAccessToken) {
                throw new Error("No token from legacy auth");
            }

            if (isOldAuToken(legacyAccessToken)) {
                tryExchangeOldAuToken(legacyAccessToken).then(result => {
                    setAuthenticatedState({
                        token: result.token,
                        refresh_token: result?.data?.refresh_token || result?.refresh_token,
                        session_id: result?.data?.session_id || result?.session_id,
                        expires_in: result?.data?.expires_in || result?.expires_in
                    });
                }).catch(exchangeError => {
                    proxyAuthState.accessToken = null;
                    proxyAuthState.isLoggedIn = false;
                    dispatch(getZeroDpConfig(null));
                    dispatch(getProfileDetailsFailure(exchangeError, false));
                    dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
                    reject(exchangeError);
                });
                return;
            }

            // Legacy returned a non-old-AU token (possibly already Bifrost from server-side migration)
            saveBifrostAuthCookies({ accessToken: legacyAccessToken });
            setAuthenticatedState({ token: legacyAccessToken });
        }).catch(legacyError => {
            proxyAuthState.accessToken = null;
            proxyAuthState.isLoggedIn = false;
            dispatch(getProfileDetailsFailure(legacyError, false));
            dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
            reject(legacyError);
        });
    });
};
/* eslint-enable max-statements */

// eslint-disable-next-line max-statements
const loginfromRefreshToken = (bifrostRefreshToken = "") => async (dispatch) => {
    try {
        const existingRefreshToken = bifrostRefreshToken || parseCookie("bifrost_refresh_token");
        const existingSessionId = parseCookie("bifrost_session_id");

        if (!existingRefreshToken || !existingSessionId) {
            throw new Error("No valid bifrost refresh session found");
        }

        const response = await bifrostService.refreshToken({
            refreshToken: existingRefreshToken,
            sessionId: existingSessionId
        });
        const accessToken = response?.token;
        proxyAuthState.accessToken = accessToken;
        proxyAuthState.isLoggedIn = true;
        dispatch(setBifrostTokens({
            secureToken: accessToken,
            refreshToken: response?.refresh_token,
            sessionId: response?.session_id
        }));
        saveBifrostAuthCookies({
            accessToken,
            refreshToken: response?.refresh_token,
            sessionId: response?.session_id,
            expiresIn: response?.expires_in
        });
        dispatch(setProfileWithToken(accessToken));
        dispatch(getZeroDpConfig(accessToken));
        return Promise.resolve(response);
    } catch (error) {
        proxyAuthState.accessToken = null;
        proxyAuthState.isLoggedIn = false;
        dispatch(getZeroDpConfig(null));
        dispatch(getProfileDetailsFailure(error, false));
        dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
        return Promise.reject(error);
    }
};

// Legacy AU auth token refresh — used by webview flows when old-app passes a
// non-Bifrost token. Tries au_to_client exchange first for old AU tokens,
// then falls back to old user-authentication-service refresh endpoints.
// eslint-disable-next-line max-statements
const loginFromLegacyRefreshToken = (refreshToken = "") => async (dispatch) => {
    try {
        const cleanToken = String(refreshToken).replace(/^Bearer\s+/i, "").trim();

        // Old AU token → exchange for Bifrost token
        if (cleanToken && isOldAuToken(cleanToken)) {
            try {
                const result = await tryExchangeOldAuToken(cleanToken);
                return dispatch(setBifrostWebviewSession(result.token));
            } catch (_exchangeError) {
                // Fall through to legacy refresh
            }
        }

        // Legacy refresh fallback
        const headersObj = {
            ...(refreshToken && {refresh_token: refreshToken})
        };
        let response;
        try {
            response = await UserAuthService.getRefreshTokenInfoV2(headersObj);
        } catch (v2Error) {
            response = await UserAuthService.getRefreshTokenInfo(headersObj);
        }
        const { access_token: accessToken, isGuestLogin, isNewUser } = response.data || {};
        proxyAuthState.accessToken = accessToken;
        proxyAuthState.isLoggedIn = true;
        dispatch(getZeroDpConfig(accessToken));
        dispatch(getProfileDetails(accessToken, isGuestLogin, isNewUser));
        return Promise.resolve(response.data);
    } catch (error) {
        proxyAuthState.accessToken = null;
        proxyAuthState.isLoggedIn = false;
        dispatch(getZeroDpConfig(null));
        dispatch(getProfileDetailsFailure(error, false));
        dispatch(setSettingGuestLoginData(GUEST_LOGIN_DATA_STATUS.COMPLETED));
        return Promise.reject(error);
    }
};

const updateProfileInit = () => ({
    type: Types.UPDATE_PROFILE
});

const updateProfileSuccess = (userData) => ({
    type: Types.UPDATE_PROFILE_SUCCESS,
    userData
});

const updateProfileFailure = (error) => ({
    type: Types.UPDATE_PROFILE_FAILURE,
    error
});

const updateProfile = (payload) => (dispatch, getState) => {
    // Skip UMS call when both names are empty — prevents overwriting a valid name
    if (!payload.firstName && !payload.lastName) {
        return Promise.resolve();
    }
    dispatch(updateProfileInit());
    const { user: { secureToken: token, email, isNewUser } } = getState();
    const updateRequest = umsService.updateUserProfile(token, {
        first_name: payload.firstName,
        last_name: payload.lastName
    });
    return new Promise((resolve, reject) => {
        updateRequest.then(response => {
            const userData = {
                firstName: payload.firstName,
                lastName: payload.lastName,
                middleName: payload.middleName,
                mobile: payload.phone,
                fullName: payload?.fullName ? `${payload.fullName}` : `${payload.firstName || ""} ${payload.middleName || ""} ${payload.lastName || ""}`.trim().replace("  ", " ")
            };
            const whatsappOptIn =  payload.whatsappOptIn || false;
            const clevertapData = {
                mobile: payload.phone,
                fullName: userData.fullName,
                email,
                whatsappOptIn
            };
            if (!isNewUser) {
                updateCleverTapProfile(clevertapData);
            } else {
                cleverTapLogin(clevertapData);
            }
            dispatch(updateProfileSuccess(userData));
            // dispatch(getProfileDetails(token));
            resolve(response);
        }).catch(error => {
            dispatch(updateProfileFailure(error));
            reject(error);
        });
    });
};

const setFirstLoad = () => ({
    type: Types.SET_FIRST_LOAD
});

const updateWebviewStatus = (isWebview) => ({
    type: Types.UPDATE_WEBVIEW_STATUS,
    isWebview
});

const setGAId = (gaId) => ({
    type: Types.SET_GA_ID,
    gaId
});

const setShowAllowTracking = (showAllowTracking) => ({
    type: Types.SET_SHOW_ALLOW_TRACKING,
    showAllowTracking
});

const setShowSpitPaymentModal = (showSplitPaymentModal) => ({
    type: Types.SET_SHOW_SPLIT_PAYMENT_MODAL,
    showSplitPaymentModal
});

const getTokenInfo = () => (dispatch) => {
    return dispatch(getRefreshTokenInfo());
};

const verifyOtp = (params) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        bifrostService.verifyOtp({
            otp: params?.otp || params?.token,
            mobileNumber: params?.username,
            countryCode: "+61",
            useEmailOtp: params?.addressType === AUTH_ADDRESS.EMAIL
        })
            .then(response => {
                const accessToken = response?.token;
                dispatch(setBifrostTokens({
                    secureToken: accessToken,
                    refreshToken: response?.refresh_token,
                    sessionId: response?.session_id
                }));
                // Skip reset if on-fly modal is open (login was triggered from within the modal)
                const { preApprovalOnFly: { isModalOpen: paofModalOpen } = {} } = getState();
                if (!paofModalOpen) {
                    dispatch({ type: resetReducerKeys.RESET_PRE_APPROVAL_ON_FLY });
                }
                dispatch(setProfileWithToken(accessToken));
                saveBifrostAuthCookies({
                    accessToken,
                    refreshToken: response?.refresh_token,
                    sessionId: response?.session_id,
                    expiresIn: response?.expires_in
                });
                dispatch(postUserLoginEvent({accessToken}));
                resolve({
                    ...response,
                    access_token: accessToken
                });
            })
            .catch(error => reject(error));
    });
};

const logoutSuccess = () => ({
    type: Types.LOGOUT_SUCCESS
});

const logoutFailure = () => ({
    type: Types.LOGOUT_FAILURE
});

const logout = (logoutSuccessCallback = () => {}) => (dispatch, getState) => {
    dispatch(updateProfileInit());
    const {
        user: {
            loginType,
            secureToken,
            sessionId
        }
    } = getState();
    return new Promise((resolve, reject) => {
        bifrostService.logout({ accessToken: secureToken, sessionId }).then(response => {
            // Also call legacy logout to invalidate old AU tokens (best-effort)
            UserAuthService.logout().catch(() => {});
            dispatch(resetCheckoutData());
            if (loginType !== LOGIN_TYPE.PRE_APPROVAL) dispatch(resetPreApproval());
            clearItem(LOCAL_STORAGE_KEYS.userProfile);
            clearItem(LOCAL_STORAGE_KEYS.financeUniqueId);
            saveCookie(ISLOGGEDIN_COOKIE, false);
            dispatch(logoutSuccess());
            dispatch({ type: resetReducerKeys.RESET_PRE_APPROVAL_ON_FLY });
            proxyAuthState.accessToken = null;
            proxyAuthState.isLoggedIn = false;
            clearBifrostAuthCookies();
            resolve(response);
            logoutSuccessCallback();
        }).catch(error => {
            // Also call legacy logout on bifrost failure (best-effort)
            UserAuthService.logout().catch(() => {});
            proxyAuthState.accessToken = null;
            proxyAuthState.isLoggedIn = false;
            clearBifrostAuthCookies();
            dispatch(logoutFailure(error));
            reject(error);
        });
    });
};

const verifySignInRequest = (addressType) => ({
    type: Types.VERIFY_GOOGLE_SIGNIN_REQUEST,
    addressType
});
const verifySignInSuccess = (addressType) => ({
    type: Types.VERIFY_GOOGLE_SIGNIN_SUCCESS,
    addressType
});
const verifySignInFailure = (addressType) => ({
    type: Types.VERIFY_GOOGLE_SIGNIN_FAILURE,
    addressType
});

const fireCleverTapLoginEvent = (eventName, data = {}) => {
    const deviceType = getDeviceType();
    const eventFn = deviceType === "MOBILE" ? mobileCleverTapEvent : desktopCleverTapEvent;
    eventFn(eventName, { platform: deviceType === "MOBILE" ? "msite" : "desktop", ...data });
};

// eslint-disable-next-line max-statements
const handleBifrostLoginSuccess = (response, params) => (dispatch, getState) => {
    dispatch(verifySignInSuccess(params.addressType));
    dispatch(setTestDriveVariant({email: params.username, testDriveVariant: true}));
    const accessToken = response?.token;
    // Determine primary identifier type based on how user logged in
    const isEmailLogin = params?.addressType === AUTH_ADDRESS.EMAIL
        || params?.addressType === AUTH_ADDRESS.GOOGLE
        || params?.addressType === AUTH_ADDRESS.APPLE;
    dispatch(setPrimaryIdentifierType(isEmailLogin ? "email" : "phone"));
    dispatch(setBifrostTokens({
        secureToken: accessToken,
        refreshToken: response?.refresh_token,
        sessionId: response?.session_id
    }));
    // Skip reset if on-fly modal is open (login was triggered from within the modal)
    const { preApprovalOnFly: { isModalOpen: paofModalOpen } = {} } = getState();
    if (!paofModalOpen) {
        dispatch({ type: resetReducerKeys.RESET_PRE_APPROVAL_ON_FLY });
    }
    dispatch(setProfileWithToken(accessToken));
    dispatch(getZeroDpConfig(accessToken));
    saveBifrostAuthCookies({
        accessToken,
        refreshToken: response?.refresh_token,
        sessionId: response?.session_id,
        expiresIn: response?.expires_in
    });
    dispatch(postUserLoginEvent({accessToken}));
    fireCleverTapLoginEvent("LOGIN_SUCCESS", { identifier: params.username, auth_method: params.addressType, is_new_user: response?.is_new_user });
    return { ...response, access_token: accessToken };
};

// eslint-disable-next-line max-statements, complexity
const verifySignIn = (params) => (dispatch) => {
    dispatch(verifySignInRequest(params.addressType));

    // Google/Apple SSO now use full-page redirect (handled by BifrostAuthCallback page)
    if (params.addressType === AUTH_ADDRESS.GOOGLE || params.addressType === AUTH_ADDRESS.APPLE) {
        return Promise.resolve();
    }

    // OTP login (phone/email) uses Bifrost
    fireCleverTapLoginEvent("LOGIN_OTP_SUBMITTED", { identifier: params.username, auth_method: params.addressType });
    return new Promise((resolve, reject) => {
        bifrostService.verifyOtp({
            otp: params?.token || params?.otp,
            mobileNumber: params?.username || params?.mobile,
            countryCode: "+61",
            useEmailOtp: params?.addressType === AUTH_ADDRESS.EMAIL,
            metadata: params?.metadata
        })
            .then(response => {
                const result = dispatch(handleBifrostLoginSuccess(response, params));
                resolve(result);
            })
            .catch((error) => {
                dispatch(verifySignInFailure(params.addressType));
                fireCleverTapLoginEvent("LOGIN_FAILED", { identifier: params.username, auth_method: params.addressType, error: error?.message || "" });
                reject(error);
            });
    });
};

// eslint-disable-next-line no-unused-vars
const sendOTP = (identifier, addressType = AUTH_ADDRESS.PHONE, isResend = false) => () => {
    fireCleverTapLoginEvent("LOGIN_OTP_REQUESTED", { identifier, auth_method: addressType });
    return new Promise((resolve, reject) => {
        bifrostService.sendOtp(identifier, "+61", { resendOtp: isResend, useEmailOtp: addressType === AUTH_ADDRESS.EMAIL })
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

// Backward-compatible: some callers still do `openLoginPopupConnect(true)`.
// Normalize payload so it never crashes on destructuring.
const openLoginPopup = (payload = {}) => {
    if (payload === true) {
        payload = {};
    }
    const { additionalInfo = {} } = payload || {};
    return {
        type: Types.OPEN_LOGIN_POPUP,
        additionalInfo
    };
};

const setLoginType = (data) => ({
    type: Types.SET_LOGIN_TYPE,
    data
});

const closeLoginPopup = () => ({
    type: Types.CLOSE_LOGIN_POPUP
});

const getSeoListInit = () => ({
    type: Types.SEO_HEADER_MENU
});

const getSeoListSuccess = (data, params) => ({
    type: Types.SEO_HEADER_MENU_SUCCESS,
    data,
    params
});

const getSeoListFailure = (data, params) => ({
    type: Types.SEO_HEADER_MENU_SUCCESS,
    data,
    params
});

const getSeoList = () => (dispatch) => {
    dispatch(getSeoListInit());
    return new Promise((resolve, reject) => {
        ListingServiceAU.getMenuSeoList()
            .then((response = {}) => {
                dispatch(getSeoListSuccess(response.data));
                resolve(response);
            })
            .catch((error) => {
                dispatch(getSeoListFailure(error));
                reject(error);
            });
    });
};

const setCurrentScreen = (data) => {
    let screenName = data;
    if (typeof window !== "undefined") {
        screenName = getItem("home_screen");
        if (!screenName) {
            setItem(screenName, "home_screen");
        }
    }
    return ({
        type: Types.SET_CURRENT_LOGO_URL,
        data: screenName
    });
};

const getGuestToken = (params) => (dispatch, getState) => {
    dispatch(verifySignInRequest(params.addressType));
    const { user: { affiliateSource: source, isAffiliate, gaId } } = getState();
    const headersObj = {
        ...(isAffiliate && {referrersource: source})
    };
    const {clientId = ""} = JSON.parse(parseCookie(emitEventNames.desktop.TRACKING_CONSENT)) || {};
    params = {...params, clientId: gaId || clientId || ""};
    return new Promise((resolve, reject) => {
        UserAuthService.getGuestTokenInfo(params, headersObj)
            .then(response => {
                const {access_token: token, isGuestLogin} = response.data;
                dispatch(verifySignInSuccess(params.addressType));
                dispatch(setSecureToken(token, isGuestLogin));
                dispatch(getZeroDpConfig(token));
                return resolve(response.data);
            })
            .catch((error) => {
                // eslint-disable-next-line no-debugger
                dispatch(verifySignInFailure(params.addressType));
                reject(error);
            });
    });
};

const setProfileDetails = (data) => {
    return {
        type: Types.SET_PROFILE_DETAILS,
        data
    };
};

const clearUserDataforGuestLogin = (data = {}) => (dispatch) => {
    dispatch(populateCheckoutPersonalData(data || {}));
    // dispatch(setSecureToken());
};

const setHideSiteHeader = (data) => ({
    type: Types.HIDE_SITE_HEADER,
    data
});

const getUserLocationInit = () => {
    return {
        type: Types.GET_LOCATION_INIT
    };
};

const getUserLocationSuccess = (data) => {
    return {
        type: Types.GET_LOCATION_SUCCESS,
        data
    };
};

const getUserLocationFailure = (error) => {
    return {
        type: Types.GET_LOCATION_FAILURE,
        error
    };
};

const getUserGeoLocation = () => (dispatch) => {
    dispatch(getUserLocationInit());
    return new Promise((resolve, reject) => {
        geoLocationService.getGeoLocationData()
            .then(response => {
                dispatch(getUserLocationSuccess(response.data));
                return resolve(response.data);
            })
            .catch((error) => {
                dispatch(getUserLocationFailure(error));
                reject(error);
            });
    });
};

const closeClpNudge = () => ({
    type: Types.CLOSE_CLP_SALE_NUDGE
});

const closeClpNudgeHandler = () => (dispatch) => {
    dispatch(closeClpNudge());

};

const clpSaleAnimationSeen = () => ({
    type: Types.CLP_SALE_ANIMATION_SEEN
});

const clpSaleAnimationSeenHandler = () => (dispatch) => {
    dispatch(clpSaleAnimationSeen());

};

const setCurrentBrowser = (data) => ({
    type: Types.SET_CURRENT_BROWSER,
    data
});

const setIsSSR = (data) => ({
    type: Types.SET_IS_SSR,
    isSSR: data
});

const updateRecentlyViewedCars = (data = "") => {
    return ({
        type: Types.UPDATE_RECENTLY_VIEWED_CARS,
        data
    });
};

const setTradeInInterest = (interestedInTradein = null) => {
    return {
        type: Types.SET_TRADE_IN_INTEREST,
        interestedInTradein
    };
};

const updateTradeInInterest = (orderId, interestedInTradein) => (dispatch, getState) => {
    const {
        user: { secureToken }
    } = getState();

    return new Promise((resolve, reject) => {
        testDriveService.updateTradeInInterest(secureToken, orderId, interestedInTradein)
            .then(response => {
                if (response.data) {
                    dispatch(setTradeInInterest(interestedInTradein));
                    resolve(response.data);
                }
            })
            .catch(error => {
                dispatch(setTradeInInterest(null));
                reject(error);
            });
    });
};

const getTradeInInterest = (orderId) => (dispatch, getState) => {
    const {
        user: { secureToken }
    } = getState();

    return new Promise((resolve, reject) => {
        testDriveService.getTradeInInterest(secureToken, orderId)
            .then(response => {
                if (response?.data) {
                    dispatch(setTradeInInterest(response?.data?.interestedInTradein));
                } else {
                    dispatch(setTradeInInterest(null));
                }
                resolve(response?.data);
            })
            .catch(error => {
                dispatch(setTradeInInterest(null));
                reject(error);

            });
    });
};
const updateIsFirstUserSession = (data) => ({
    type: Types.UPDATE_IS_FIRST_USER_SESSION,
    data
});

const openLocationModal = () => ({
    type: Types.OPEN_LOCATION_MODAL
});

const closeLocationModal = () => ({
    type: Types.CLOSE_LOCATION_MODAL
});

const toggleLeadGenerationForm = (value) => ({
    type: Types.TOGGLE_LEAD_GENERATION_FORM,
    value
});

export {
    setProfileName,
    setMobile,
    setProfileMobile,
    setEmail,
    setProfileWithToken,
    setBifrostWebviewSession,
    setCheckAuth,
    setFirstLoad,
    updateWebviewStatus,
    setGAId,
    updateProfile,
    setLastVerifiedMobile,
    getTokenInfo,
    verifyOtp,
    logout,
    logoutSuccess,
    getRefreshTokenInfo,
    loginfromRefreshToken,
    loginFromLegacyRefreshToken,
    verifySignIn,
    sendOTP,
    getProfileDetails,
    setSecureToken,
    openLoginPopup,
    closeLoginPopup,
    setShowAllowTracking,
    setShowSpitPaymentModal,
    getSeoList,
    setAffiliateSource,
    setLoginType,
    setCurrentScreen,
    getZeroDpConfig,
    getZeroDpConfigSuccess,
    getZeroDpConfigFailure,
    setInitialZeroDpOptimizeVariant,
    getGuestToken,
    setProfileDetails,
    clearUserDataforGuestLogin,
    setHideSiteHeader,
    getUserGeoLocation,
    closeClpNudgeHandler,
    clpSaleAnimationSeenHandler,
    setCurrentBrowser,
    setIsSSR,
    updateRecentlyViewedCars,
    updateTradeInInterest,
    getTradeInInterest,
    updateIsFirstUserSession,
    setIsValueCheckLoginDone,
    setUserEmailViaGuestLogin,
    setUserMobileViaGuestLogin,
    setUserEmailViaGuestLoginInit,
    setUserMobileViaGuestLoginInit,
    getUserLocationSuccess,
    getUserLocationInit,
    getUserLocationFailure,
    openLocationModal,
    closeLocationModal,
    toggleLeadGenerationForm,
    setBifrostTokens,
    setPrimaryIdentifierType,
    openSecondaryIdentifierModal,
    closeSecondaryIdentifierModal,
    checkAndOpenSecondaryModal,
    exchangeUmsAuthCode
};
